import { render, staticRenderFns } from "./FDEdit.vue?vue&type=template&id=45db2fd6&"
import script from "./FDEdit.vue?vue&type=script&lang=js&"
export * from "./FDEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports